import { graphql, useStaticQuery } from "gatsby"

export const useAllCompanies = (locale) => {
  const { allCosmicjsCompanies } = useStaticQuery(graphql`
    query {
      allCosmicjsCompanies {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
            created_at
            published_at
            modified_at
            metadata {
              company_logo {
                imgix_url
              }
              company_location
              company_number_employees
              company_industry_filter
              company_size_filter
            }
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsCompanies.edges.map(({ node }, index) => ({
    key: index,
    id: node.id,
    slug: node.slug,
    title: node.title,
    locale: node.locale,
    type: node.type,
    content: node.content,
    created_at: node.created_at,
    published_at: node.published_at,
    modified_at: node.modified_at,
    company_logo: node.metadata?.company_logo?.imgix_url,
    company_location: node.metadata?.company_location,
    company_number_employees: node.metadata?.company_number_employees,
    company_industry_filter: node.metadata?.company_industry_filter,
    company_size_filter: node.metadata?.company_size_filter,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
